import { WorkspaceContext } from './Workspace.context';
import useWorkspace from './Workspace.hook';
import { tWorkspaceProviderProps } from './Workspace.types';

function WorkspaceProvider(props: tWorkspaceProviderProps) {
  const { children } = props;
  const workspace = useWorkspace();

  return (
    <WorkspaceContext.Provider value={workspace}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export default WorkspaceProvider;
